<div class="{{ theme }}">
  <div class="card">
    <div class="modal-header border-bottom-0 pb-0">
      <button data-testid="logout-message-close-button" type="button" class="close pull-right" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="d-flex p-3" style="align-self: center">
      <p class="text-primary font-weight-bold ml-auto mr-auto font-size-small">{{ 'HEADER.LOGOUT_QUESTION' | translate }}</p>
    </div>
    <div class="mx-auto mb-4">
      <lib-button id="user-box-logout-button" [size]="'large'" [label]="'HEADER.LOGOUT' | translate" (buttonClicked)="logout()">
      </lib-button>
    </div>
  </div>
</div>
